// INTELLIGENCE admin API (apbe /api/intelligence; brain v2 PLAN-CONCIERGE-FACTORY §9.2).
// Kept in its own module so the feature doesn't touch the shared services/api.js.
import api from './api';

const BASE = process.env.REACT_APP_API_URL || '/api';

/** The viewer's INTELLIGENCE roles (from apbe's env role lists); no database. */
export const intelligenceMe = () => api.get('/intelligence/me');

export const kbfAPI = {
  summary: () => api.get('/intelligence/kbf/summary'),
  drafts: (params) => api.get('/intelligence/kbf/drafts', { params }),
  draft: (id) => api.get(`/intelligence/kbf/drafts/${id}`),
  decide: (id, body) => api.post(`/intelligence/kbf/drafts/${id}/decision`, body),
  edit: (id, body) => api.patch(`/intelligence/kbf/drafts/${id}`, body),
  jobs: (params) => api.get('/intelligence/kbf/jobs', { params }),
  createJob: (body) => api.post('/intelligence/kbf/jobs', body),
  tasks: (params) => api.get('/intelligence/kbf/tasks', { params }),
  updateTask: (id, body) => api.patch(`/intelligence/kbf/tasks/${id}`, body),
  sources: () => api.get('/intelligence/kbf/sources'),
  createSource: (body) => api.post('/intelligence/kbf/sources', body),
  snapshot: (id) => api.get(`/intelligence/kbf/snapshots/${id}`),
  snapshotLink: (id) => api.get(`/intelligence/kbf/snapshots/${id}/view`, { params: { format: 'link' } }),
  upload: (body) => api.post('/intelligence/kbf/snapshots/upload', body),
  /** The sandboxed document's URL, for <iframe sandbox="" src=…>; never fetched into the admin page. */
  viewUrl: (id, mark) => `${BASE}/intelligence/kbf/snapshots/${id}/view${mark ? `?mark=${encodeURIComponent(mark.slice(0, 600))}` : ''}#kbf-quote`,
};

/** KB RULES: every rule in the KB (engine catalog + factory state); changes become factory jobs (kbf/manual.py). */
export const kbRulesAPI = {
  list: (params) => api.get('/intelligence/kb/records', { params }),
  get: (id, fresh) => api.get(`/intelligence/kb/records/${encodeURIComponent(id)}`, { params: fresh ? { fresh: 1 } : undefined }),
  approve: (id, body) => api.post(`/intelligence/kb/records/${encodeURIComponent(id)}/approve`, body),
  edit: (id, body) => api.post(`/intelligence/kb/records/${encodeURIComponent(id)}/edit`, body),
};

export const conciergeReviewAPI = {
  metrics: (days) => api.get('/intelligence/concierge/metrics', { params: { days } }),
  evals: () => api.get('/intelligence/concierge/evals'),
  turns: (params) => api.get('/intelligence/concierge/turns', { params }),
  turn: (id) => api.get(`/intelligence/concierge/turns/${id}`),
  annotate: (id, body) => api.post(`/intelligence/concierge/turns/${id}/annotations`, body),
  validate: (body) => api.post('/intelligence/concierge/annotations/validate', body),
  exports: () => api.get('/intelligence/concierge/exports'),
  createExport: (body) => api.post('/intelligence/concierge/exports', body),
  downloadExport: (id) => api.get(`/intelligence/concierge/exports/${id}/download`, { responseType: 'blob' }),
};

export const errMsg = (e, fallback = 'Something went wrong') => e?.response?.data?.message || e?.message || fallback;

export const fmtDate = (v) => {
  if (!v) return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};

export const usd = (n) => (n == null ? '—' : `$${Number(n).toFixed(2)}`);

/** An http(s) URL from stored data, or null: never a javascript:/data: link. */
export const safeHref = (u) => {
  try {
    const url = new URL(String(u || ''));
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null;
  } catch {
    return null;
  }
};
